import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";

export interface MapCoordinates {
    lat: number;
    lon: number;
    address: string;
}

export function mapCoordinates(state: MapCoordinates = null, action: Action) {
    switch (action.type) {
        case HallsActionTypes.UPDATE_MAP_COORDINATES:
            return {
                lat: action.payload.lat,
                lon: action.payload.lon,
                address: action.payload.address
            };

        case HallsActionTypes.PICK_SUGGESTION:
            return {
                lat: action.payload.suggestion.lat,
                lon: action.payload.suggestion.lon
            };

        default:
            return state;
    }
}
